import { axiosGET, axiosPOST } from '../../Helpers/TypeAxios'
import { urlParseParams } from "../../Helpers/helpFunction";

const routerRoot = 'chart';

export interface historyProps {
  resolution: string,
  symbol: string,
  from: string | number,
  to: string | number,
}

export default class Chart {
  history(data: historyProps) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/history?${stringUrl}`, data)
  }
  values(data: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/values?${stringUrl}`, data)
  }
  valuesValuation(data: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/values/valuation?${stringUrl}`, data)
  }
}
